export default __webpack_public_path__ + "63311334b795ce3b76e2e05bc585f6a2.ttf";